module.exports = (__webpack_require__(3))(6);


//////////////////
// WEBPACK FOOTER
// delegated ./src/events.js from dll-reference girder_plugin_large_image_annotation
// module id = 8
// module chunks = 0